var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS44(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10V22.5",
    stroke: "#8D48E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46875 33.7514C9.71947 31.833 11.429 30.257 13.4426 29.1661C15.4561 28.0752 17.7099 27.5039 20 27.5039C22.2901 27.5039 24.5439 28.0752 26.5575 29.1661C28.571 30.257 30.2805 31.833 31.5313 33.7514",
    stroke: "#8D48E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 10L20 15L5 10L20 5L35 10Z",
    stroke: "#8D48E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4531 12.8438C27.5998 14.0959 28.3573 15.6546 28.6335 17.3298C28.9096 19.0051 28.6925 20.7245 28.0084 22.2784C27.3243 23.8323 26.203 25.1537 24.781 26.0814C23.359 27.0091 21.6978 27.503 20 27.503C18.3022 27.503 16.641 27.0091 15.219 26.0814C13.797 25.1537 12.6757 23.8323 11.9916 22.2784C11.3076 20.7245 11.0904 19.0051 11.3665 17.3298C11.6427 15.6546 12.4002 14.0959 13.5469 12.8438",
    stroke: "#8D48E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS44);
export default __webpack_public_path__ + "static/media/s4-4.a219ee1cb13e138517419f9189c1fd7f.svg";
export { ForwardRef as ReactComponent };